const IssueImages = ({ issues }) => {
  const images = issues.flatMap((i) =>
    i.images.map((image) => ({ src: image, description: i.description })),
  );

  return (
    <div className="flex flex-col gap-2">
      <h4>Images</h4>
      <div className="flex items-end overflow-auto">
        {images.map((image, index) => (
          <div key={index} className="flex w-80 flex-shrink-0 flex-col gap-2">
            <a href={image.src} target="_blank" key={index} rel="noreferrer">
              <img src={`${image.src}?imageView2/2/w/300`} alt="Issue Image" />
            </a>
            <div className="text-center">{image.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default IssueImages;
